module.exports = __webpack_public_path__ + "static/img/zhyq.b3b5348.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhyq.png
// module id = gPBx
// module chunks = 0